import React, { useContext } from 'react';
import UserContext from 'src/context/UserContext';

import Alert from '../components/alert';
import Header from '../components/header';

const Restricted = () => {
  const { user } = useContext(UserContext);
  return (
    <>
      <Header title="Restricted" user={user} />
      <main role="main" className="text-center">
        <Alert variant="danger" name="Restricted">
          <p className="mb-0">
            You do not have permission to view this page. If you think this is an error,
            please contact the person that gave you access to the system for further assistance.
          </p>
        </Alert>
      </main>
    </>
  );
};

export default Restricted;
